import * as actionTypes from "./actionTypes";
import * as sessionService from "../../api/services/sessionServices";

export const getAllSessionsCompleted = (data) => ({
    type: actionTypes.GET_SESSIONS,
    sessions: data,
});

export const getAllSessions = (cinema, uuid, film, onSuccess, onError) => (dispatch) => {
    const fail = (error) => {
        if (onError) {
            onError(error);
        }
    };

    sessionService.getSessions(
        cinema,
        uuid,
        film,
        (response) => {
            // La API puede contestar algo sin `sesiones`: lo tratamos como fallo en
            // vez de dejar que reviente en los componentes.
            if (!response || !Array.isArray(response.sesiones)) {
                fail(response);
                return;
            }
            dispatch(getAllSessionsCompleted(response));
            if (onSuccess) {
                onSuccess(response);
            }
        },
        fail
    );
};